import useSwitchboard from './useSwitchboard';
import { SwitchboardSetting } from '../../types';

const useFeatureFlag = (flag: string): SwitchboardSetting | undefined => {
  const switchboard = useSwitchboard();

  return switchboard?.[flag];
};

export default useFeatureFlag;
